import { EmployeeRoleTypes } from './enums/employees/EmployeeRoleTypes';

export class EmployeeRole {
  id: number;
  employeeId: number;
  roleId: EmployeeRoleTypes;
  accountId: number;
  created: string;
}
